import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")

import { ref, Ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'POST/payroll/aggregate/query': fetchList,
} = Api

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

const searchEle = ref()
const searchObj = reactive({
  companyName: '', billId: '', applicationAmountStart: undefined,
  applicationAmountEnd: undefined, "paymentAmountStart": undefined, "paymentAmountEnd": undefined,
  salaryDateStart: '', salaryDateEnd: '', paymentTimeStart: '', paymentTimeEnd: '', paymentBankName: '', paymentStatus: '',
})
const searchHandle = () => {
  fetchData({
    query: {
      ...searchObj,
      // salaryDateStart: searchObj.salaryDate?.[0],
      // salaryDateEnd: searchObj.salaryDate?.[1],
      // paymentTimeStart: searchObj.paymentTime?.[0],
      // paymentTimeEnd: searchObj.paymentTime?.[1],
    },
  })
}
searchHandle()

const resetHandle = () => {
  searchObj.applicationAmountStart =  undefined
  searchObj.applicationAmountEnd =  undefined
  searchObj.paymentAmountStart =  undefined
  searchObj.paymentAmountEnd =  undefined
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "发放汇总-搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref_key: "searchEle",
              ref: searchEle,
              model: _unref(searchObj),
              inline: "",
              class: "searchBg"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "公司:",
                  prop: "companyName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).companyName,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).companyName) = $event)),
                      placeholder: "请选择公司",
                      filterable: "",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysCompany, (group) => {
                          return (_openBlock(), _createBlock(_component_el_option_group, {
                            label: group.label,
                            key: group.label
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (comp) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  label: comp.name,
                                  value: comp.name,
                                  key: comp.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "支付ID:",
                  prop: "billId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).billId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchObj).billId) = $event)),
                      placeholder: "请输入支付ID",
                      clearable: "",
                      maxlength: "100",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "申请金额范围:",
                  prop: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _unref(searchObj).applicationAmountStart,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchObj).applicationAmountStart) = $event)),
                      controls: false,
                      placeholder: "请输入最小金额"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_el_input_number, {
                      modelValue: _unref(searchObj).applicationAmountEnd,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchObj).applicationAmountEnd) = $event)),
                      controls: false,
                      placeholder: "请输入最大金额",
                      class: "ml-10"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "支付金额范围:",
                  prop: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _unref(searchObj).paymentAmountStart,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchObj).paymentAmountStart) = $event)),
                      controls: false,
                      placeholder: "请输入最小金额"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_el_input_number, {
                      modelValue: _unref(searchObj).paymentAmountEnd,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(searchObj).paymentAmountEnd) = $event)),
                      controls: false,
                      placeholder: "请输入最大金额",
                      class: "ml-10"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "工资月份起:",
                  prop: "salaryDateStart"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(searchObj).salaryDateStart,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(searchObj).salaryDateStart) = $event)),
                      placeholder: "开始月份",
                      "value-format": "YYYY-MM-DD",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "工资月份止:",
                  prop: "salaryDateEnd"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(searchObj).salaryDateEnd,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(searchObj).salaryDateEnd) = $event)),
                      placeholder: "结束月份",
                      "value-format": "YYYY-MM-DD",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "支付时间起:",
                  prop: "paymentTimeStart"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(searchObj).paymentTimeStart,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(searchObj).paymentTimeStart) = $event)),
                      placeholder: "开始月份",
                      "value-format": "YYYY-MM-DD",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "支付时间止:",
                  prop: "paymentTimeEnd"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(searchObj).paymentTimeEnd,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(searchObj).paymentTimeEnd) = $event)),
                      placeholder: "结束月份",
                      "value-format": "YYYY-MM-DD",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "发放银行:",
                  prop: "paymentBankName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).paymentBankName,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(searchObj).paymentBankName) = $event)),
                      placeholder: "请输入发放银行",
                      clearable: "",
                      maxlength: "100",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "支付状态:",
                  prop: "paymentStatus"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).paymentStatus,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(searchObj).paymentStatus) = $event)),
                      class: "form-input",
                      placeholder: "请选择支付状态",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "未支付",
                          value: "PAY_NO"
                        }),
                        _createVNode(_component_el_option, {
                          label: "等待支付",
                          value: "PAY_WAIT"
                        }),
                        _createVNode(_component_el_option, {
                          label: "支付成功",
                          value: "PAY_SUCCESS"
                        }),
                        _createVNode(_component_el_option, {
                          label: "支付失败",
                          value: "PAY_FAILED"
                        }),
                        _createVNode(_component_el_option, {
                          label: "已重新支付",
                          value: "PAYMENT_REISSUED"
                        }),
                        _createVNode(_component_el_option, {
                          label: "部分支付成功",
                          value: "PAY_PART_SUCCESS"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: _cache[12] || (_cache[12] = ($event: any) => {searchEle.value.resetFields(); resetHandle()})
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: searchHandle
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height),
      class: "mt-10"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "公司",
          prop: "companyName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "支付ID",
          prop: "billId"
        }),
        _createVNode(_component_el_table_column, {
          label: "申请金额",
          prop: "applicationAmount"
        }),
        _createVNode(_component_el_table_column, {
          label: "支付金额",
          prop: "paymentAmount"
        }),
        _createVNode(_component_el_table_column, {
          label: "工资月份",
          prop: "salaryDate"
        }),
        _createVNode(_component_el_table_column, {
          label: "发放银行",
          prop: "paymentBankName"
        }),
        _createVNode(_component_el_table_column, {
          label: "支付日期",
          prop: "paymentTime"
        }),
        _createVNode(_component_el_table_column, {
          label: "支付状态",
          prop: "paymentStatus"
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(MI_total),
      "page-size": _unref(size),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[13] || (_cache[13] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      class: "mt-10",
      disabled: _unref(MI_identify),
      "page-sizes": [30, 50, 200, 500],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "page-size", "currentPage", "disabled", "onCurrentChange", "onSizeChange"])
  ]))
}
}

})